import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { PartialInvoiceItem } from '../models';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';
import { ShippingProvider } from '../../shipping/models';

@Injectable()
export class PartialInvoiceItemsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createPartialInvoiceItem(
    payload: PartialInvoiceItem
  ): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<ShippingProvider>(
      'ROLE_MWS_PARTIAL_INVOICE_ITEM_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/partial_invoice_items`, payload)
    );
  }

  readPartialInvoiceItem(iri: string): Observable<PartialInvoiceItem> {
    return this.rolesService.userHasRoleFilter<PartialInvoiceItem>(
      'ROLE_MWS_PARTIAL_INVOICE_ITEM_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  updatePartialInvoiceItem(
    iri: string,
    payload: PartialInvoiceItem
  ): Observable<PartialInvoiceItem> {
    return this.rolesService.userHasRoleFilter<PartialInvoiceItem>(
      'ROLE_MWS_PARTIAL_INVOICE_ITEM_EDIT',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.updateObject(iri, payload, true)
    );
  }

  deletePartialInvoiceItem(iri: string): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_PARTIAL_INVOICE_ITEM_DELETE',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.deleteObject(iri, true)
    );
  }
}
